(function () {
  var SECTION_TYPE = 'caring-for-reef';

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function cardStep(track) {
    var first = track.querySelector('[data-caring-card]');
    if (!first) return track.clientWidth;
    var rect = first.getBoundingClientRect();
    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
    return rect.width + gap;
  }

  function updateEdgeState(section, track, prev, next) {
    var overflows = track.scrollWidth - track.clientWidth > 1;
    if (!overflows) {
      // Arrows stay visible (they're a brand-design element in the layout)
      // but don't grey out — they simply have nowhere to scroll to.
      if (prev) prev.setAttribute('aria-disabled', 'false');
      if (next) next.setAttribute('aria-disabled', 'false');
      return;
    }
    var atStart = track.scrollLeft <= 1;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    if (prev) prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    if (next) next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
  }

  function revealDescriptions(section) {
    var targets = section.querySelectorAll('[data-caring-reveal]');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in-view'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    targets.forEach(function (el) { io.observe(el); });
  }

  function initSection(section) {
    if (!section || section.dataset.caringInit === '1') return;
    section.dataset.caringInit = '1';

    var track = section.querySelector('[data-caring-track]');
    if (!track) return;

    var prev = section.querySelector('[data-caring-prev]');
    var next = section.querySelector('[data-caring-next]');

    function scrollByDir(dir) {
      var step = cardStep(track);
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
    if (next) next.addEventListener('click', function () { scrollByDir(1); });

    var onScroll = debounce(function () {
      updateEdgeState(section, track, prev, next);
    }, 60);
    track.addEventListener('scroll', onScroll, { passive: true });

    var onResize = debounce(function () {
      updateEdgeState(section, track, prev, next);
    }, 120);
    window.addEventListener('resize', onResize);

    updateEdgeState(section, track, prev, next);
    revealDescriptions(section);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    if (e.target.matches && e.target.matches('[data-section-type="' + SECTION_TYPE + '"]')) {
      initSection(e.target);
    } else {
      initAll(e.target);
    }
  });
})();
